import { render, staticRenderFns } from "./step-client.vue?vue&type=template&id=4a082eb0&"
import script from "./step-client.vue?vue&type=script&lang=js&"
export * from "./step-client.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports